<form [formGroup]="form" class="container-fluid container-filter" autocomplete="off">

    <div class="animated fadeIn">

        <div class="row">
            <div class="col-md-12">
                <h4 style="display:inline">{{ title }} de la Solicitud de Campaña</h4>
                <h4 style="display:inline">{{ solicitudCam?.Codigo }}</h4>
                <h5 style="display:inline; margin-left: 8px">
                    <span>
                        <img *ngIf="solicitudCam.IdEstadoSolicitudCam" class="estado-icono-big" container="body" src="{{ solicitudCam.IdEstadoSolicitudCam | IconoEstadoSolicitudCam }}" ngbTooltip="{{ solicitudCam?.EstadoSolicitudCam }}" />
                        <img *ngIf="!solicitudCam.IdEstadoSolicitudCam" class="estado-icono-big" container="body" src="{{ null | IconoEstadoSolicitudCam }}" ngbTooltip="{{ 'Nueva' }}" />
                    </span>
                </h5>
            </div>
        </div>        

        <div class="row">
            <div class="col-md-12">
    
                <div class="row">
    
                    <div class="col-md-12">
                        <div class="card card-accent-success animated fadeIn">
                            <a class="card-header-a" (click)="isCollapsedCabecera = !isCollapsedCabecera" [attr.aria-expanded]="!isCollapsedCabecera" aria-controls="collapseExample">
                                <div class="card-header-buscador">
                                    <i class="fa fa-file-text-o"></i> Datos Básicos de la Solicitud de Campaña
                                    <i *ngIf="isCollapsedCabecera" class="fa fa-caret-down float-right"></i>
                                    <i *ngIf="!isCollapsedCabecera" class="fa fa-caret-up float-right"></i>
                                </div>
                            </a>
                            <div class="card-body-detalle">
                                <div class="collapse group-filtros" id="collapsedCabecera" [ngbCollapse]="isCollapsedCabecera">
    
                                    <div class="row">
    
                                        <div class="form-group col-xl-2 col-lg-4 col-md-4 col-sm-4">
                                            <label class="col-form-label" for="Campania" title="Campaña Específica">Campaña</label>
                                            <input formControlName="Campania" name="Campania" readonly class="form-control" id="Campania" type="text" value="" title="{{ form.value.Campania }}">
                                        </div>
    
                                        <div class="form-group col-xl-2 col-lg-4 col-md-4 col-sm-4">
                                            <label class="col-form-label" for="Periodo" title="Periodo de la Campaña Específica">Periodo</label> <label class="small">(de la "Campaña")</label>
                                            <input formControlName="Periodo" name="Periodo" readonly class="form-control" id="Periodo" type="text" value="" title="{{ form.value.Periodo }}">
                                        </div>
        
                                        <div class="form-group col-xl-2 col-lg-4 col-md-4 col-sm-4">
                                            <label class="col-form-label" for="DescripcionComunidad" title="Comunidad Autónoma del Periodo">Com. Aut.</label> <label class="small">(del "Periodo")</label>
                                            <input formControlName="DescripcionComunidad" name="DescripcionComunidad" readonly class="form-control" id="DescripcionComunidad" type="text" value="" title="{{ form.value.DescripcionComunidad }}">
                                        </div>
        
                                        <div class="form-group col-xl-2 col-lg-4 col-md-4 col-sm-4">
                                            <label class="col-form-label" for="EntidadAuditora" title="Entidad Auditora de la Comunidad Autónoma">Ent. Audit.</label> <label class="small">(de la "C.A.")</label>
                                            <input formControlName="EntidadAuditora" name="EntidadAuditora" readonly class="form-control" id="EntidadAuditora" type="text" value="" title="{{ form.value.EntidadAuditora }}">
                                        </div>
    
                                        <div class="form-group col-xl-2 col-lg-4 col-md-4 col-sm-4">
                                            <label class="col-form-label" for="TipoSolicitudCam" title="Tipo de Recinto del Periodo">Tipo de Recinto</label>
                                            <input formControlName="TipoSolicitudCam" name="TipoSolicitudCam" readonly class="form-control" id="TipoSolicitudCam" type="text" value="" title="{{ form.value.TipoSolicitudCam }}">
                                        </div>

                                        <div class="form-group col-xl-2 col-lg-4 col-md-4 col-sm-4">
                                            <label class="col-form-label" for="PeriodoSuperficieMax" title="Tipo de Recinto del Periodo">Superficie Máxima</label> <label class="small">(ha)</label>
                                            <input formControlName="PeriodoSuperficieMax" name="PeriodoSuperficieMax" readonly class="form-control" id="PeriodoSuperficieMax" type="text" value="" title="{{ form.value.PeriodoSuperficieMax }}">
                                        </div>
        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>        

    </div>
</form>